import React from 'react';
import {
  Box,
  Typography,
  Drawer,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Divider,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

interface ImportErrorsDrawerProps {
  open: { status: boolean, type: string | null };
  onClose: () => void;
  errors: string[];
  batchId: string;
}

export const ImportErrorsDrawer: React.FC<ImportErrorsDrawerProps> = ({
  open,
  onClose,
  errors,
  batchId,
}) => {
  return (
    <Drawer
      anchor="right"
      open={open.status}
      onClose={onClose}
      sx={{
        '& .MuiDrawer-paper': {
          width: { xs: '100%', sm: 400 },
          maxWidth: '100vw',
        },
      }}
    >
      <Box
        sx={{
          p: 2,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant="h6" component="h2">
          Import {open.type} - {batchId}
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Divider />
      <Box sx={{ flex: 1, overflow: 'auto' }}>
        {errors.length === 0 ? (
          <Box sx={{ p: 2, textAlign: 'center' }}>
            <Typography variant="body2" color="text.secondary">
              No errors to display
            </Typography>
          </Box>
        ) : (
          <List>
            {errors.map((error, index) => (
              <React.Fragment key={index}>
                <ListItem alignItems="flex-start">
                  <ListItemText
                    primary={
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'flex-start',
                          gap: 1,
                        }}
                      >
                        <ErrorOutlineIcon
                          color={open.type === 'Warnings' ? 'warning' : 'error'}
                          fontSize="small"
                        />
                        <Typography variant="body2" color={open.type === 'Warnings' ? 'warning' : 'error'}>
                          {error}
                        </Typography>
                      </Box>
                    }
                  />
                </ListItem>
                {index < errors.length - 1 && (
                  <Divider variant="inset" component="li" />
                )}
              </React.Fragment>
            ))}
          </List>
        )}
      </Box>
    </Drawer>
  );
};